import * as React from 'react';

import { cn } from '@/lib/utils';

interface TextareaProps extends React.ComponentProps<'textarea'> {
  label?: string;
  error?: string;
}

function Textarea({ className, label, error, ...props }: TextareaProps) {
  return (
    <div className='w-full'>
      {label && (
        <label className='mb-2 block text-sm font-medium text-gray-70'>
          {label}
        </label>
      )}
      <textarea
        data-slot='textarea'
        className={cn(
          'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          error &&
            'border-destructive-50 focus-visible:border-destructive-50 focus-visible:ring-destructive-50/20',
          className
        )}
        {...props}
      />
      {error && <p className='mt-1 text-sm text-destructive-60'>{error}</p>}
    </div>
  );
}

export { Textarea };
